import React from 'react';
import moment from 'moment';
import { Stack } from '@mui/material';
import { DateFormats } from 'constants/common';

import { FieldChange } from './FieldChange';
import { AvailabilityChanges } from '../../../../types';

const formatDate = (value: string | null): string => {
  if (!value) return '—';
  return moment(value).format(DateFormats.DateTimeMedium24Hour);
};

interface AvailabilityRenderProps {
  changes: AvailabilityChanges;
}

export const AvailabilityRender = ({ changes }: AvailabilityRenderProps) => (
  <Stack gap="0.5rem">
    {changes.firstDateAvailable && (
      <FieldChange
        label="First Date Available"
        before={formatDate(changes.firstDateAvailable.before)}
        after={formatDate(changes.firstDateAvailable.after)}
      />
    )}

    {changes.lastDateAvailable && (
      <FieldChange
        label="Last Date Available"
        before={formatDate(changes.lastDateAvailable.before)}
        after={formatDate(changes.lastDateAvailable.after)}
      />
    )}
  </Stack>
);
